import { DropdownMenuItemCombinedProps } from './types';

const usePresenter = (props: DropdownMenuItemCombinedProps): DropdownMenuItemCombinedProps => {
  return props;
};

export default usePresenter;
